import React from "react";
import LinkNavigation from "./LinkNavigation";
import Spacer from "src/organisms/PageComponentList/Spacer";

const PageComponent = (props) => (
  <>
    <LinkNavigation {...props} />
    <Spacer />
  </>
);

export default PageComponent;
